import { FormOutlined } from '@ant-design/icons';
import { BasketballMessage, BasketballMessagesPagination } from '@hefe/models';
import { Button, Col, Row } from 'antd';
import { t } from '@hefe/i18n';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import MessagesComposerComponent from '../messages-composer/messages.composer.component';
import MessagesDetailComponent from '../messages-detail/messages-detail.component';
import MessagesListComponent from '../messages-list/messages-list.component';

export interface MessagesAppComponentProps {
  allowCompose: boolean;
  loading: boolean;
  messages: BasketballMessagesPagination;
  fetchMoreMessages: any;
  mode: 'admin' | 'team' | 'user';
}

export default function MessagesAppComponent(props: MessagesAppComponentProps) {
  const dispatch = useAppDispatch();
  const [compose, setCompose] = useState(false);
  const [selectedMessage, setSelectedMessage] =
    useState<BasketballMessage | null>(null);

  useEffect(() => {
    dispatch(props.fetchMoreMessages(1));
  }, []);

  return (
    <Row gutter={[20, 20]}>
      {props.allowCompose && (
        <Col xs={24}>
          <Button icon={<FormOutlined />} onClick={() => setCompose(true)}>
            {t('new_message')}
          </Button>
        </Col>
      )}
      <Col xs={24} sm={12} lg={8}>
        <MessagesListComponent
          onMessageClick={(message) => setSelectedMessage(message)}
          {...props}
        />
      </Col>
      <Col xs={24} sm={12} lg={16}>
        {compose ? (
          <MessagesComposerComponent
            mode={props.mode}
            onCancelClick={() => setCompose(false)}
          />
        ) : (
          <MessagesDetailComponent
            mode={props.mode}
            message={selectedMessage}
            allowDelete={props.allowCompose}
            messageDeleted={() => setSelectedMessage(null)}
          />
        )}
      </Col>
    </Row>
  );
}
